export const environment = {
    production: false,
    API_URL: 'https://dev.eo.coditas.org/eointbk/api/v1',
    STUDENT_PORTAL_URL: 'https://student-portal.eo.coditas.org',
    USE_MOCK_DATA: false,
    RECAPTCHA_SITE_KEY: '6LfW_aosAAAAAH9Cyaz8yY0HMB7Z_rOh61qcKzoI',
};
